import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { useSelector } from "react-redux";

// CSS
import styles from "./mainLayout.module.scss";

const override = {
  display: "block",
  position: "fixed",
  left: "0",
  right: "0",
  top: "50%",
  bottom: "0",
  margin: "auto",
  borderColor: "#265436",
};

const MainLayout = () => {
  const [sidebar, setSidebar] = useState();
  const loaderState = useSelector((state) => state.loader) || {};
  const { loading } = loaderState;

  return (
    <div
      className={`${styles.mainLayout} mainLayout d-flex align-items-start flex-wrap`}
    >
      {loading && (
        <div className="loading-overlay position-absolute">
          <FadeLoader
            color={"#265436"}
            loading={loading}
            cssOverride={override}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
      <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
      <main className={`${styles.MainBody} MainBody ms-auto position-relative`}>
        <Header sidebar={sidebar} setSidebar={setSidebar} />
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
